import Vue from 'vue'
import AppVue from './App.vue'
import router from './router'
import store from './store'

// mock
// import './mock/mock'

// config
import APP from './config/app.config'
import ETC from './config/etc.config'
// filters
import './filters'
// utils
import FastClick from 'fastclick'
// axios
import ETC_AXIOS from './api/etc.axios'
import { zuizhuhaiInit } from '@/utils/channel/zuizhuhai'

FastClick.attach(document.body)

// 生产环境提示
Vue.config.productionTip = false

// 是否iPhonex
Vue.use({
  install(Vue) {
    console.log(navigator.userAgent.toLowerCase())
    Vue.mixin({
      data: () => ({
        isRichMan: /iphone\s(x|1\d)/gi.test(navigator.userAgent.toLowerCase())
      })
    })
  }
})

let v
initApp()
let times = 0
function initApp() {
  ETC_AXIOS.interceptors.response.use(
    response => {
      if (response.status === 200 && response.data) {
        const res = response.data
        if (res.code === 200042) {
          // console.log('%c response url: ' + response.config.url.replace(APP.HTTP_URL, '') + ' => success:', 'color: blue', response.data.data)
          return res
        }
        if (res.code === 0) {
          // console.log('%c response url: ' + response.config.url.replace(APP.HTTP_URL, '') + ' => success:', 'color: blue', response.data.data)
          return res.data
        }
        if (res.code === -1) {
          setTimeout(() => {
            v.$children[0].$refs.toast.$emit('loadingClose')
            if (res.msg && res.msg.trim() !== 'REPEAT CALL') {
              v.$children[0].$refs.confirm.$emit('showConfirm', {
                content: res.msg
              })
            }
          })
          return Promise.reject(new Error('code with -1'))
        }
        if (res.code === -1000) {
          // console.warn('!!! request warn ' + res.msg)
          // 重新登录
          if (times > 3) return Promise.reject(res)
          times++
          if (localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL) === 'zuizhuhai') {
            setTimeout(() => {
              v.$children[0].$refs.toast.$emit('loadingClose')
            })
            return zuizhuhaiInit()
              .then(res => {
                return Promise.resolve(res)
              })
              .catch(() => {
                return Promise.reject(res)
              })
          }
          let loginCode = localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID)
          if (!loginCode) {
            if (router.currentRoute.name !== 'verifyPhone') {
              router.push({
                name: 'verifyPhone',
                query: { redircet: router.currentRoute.path }
              })
            }
            return Promise.reject(res)
          }
          return ETC_AXIOS.post(
            localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL) ===
              'pahcz'
              ? APP.HTTP_URL2 + '/auth/third-login'
              : '/auth/h5-login',
            {
              code: loginCode.replace(/ /g, '+'), // 招行地址中的code未经转码就放到浏览器中，导致加号被浏览器识别为空格，故将code中空格全部转为加号，数据库中带空格的账号也需同步将空格转换为加号
              third_type:
                ETC.APP_LOGIN_TYPES[localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)]
            }
          ).then(res => {
            localStorage.setItem(ETC.LOCAL_STORAGE_KEY.TOKEN, res.token)
            localStorage.setItem(ETC.LOCAL_STORAGE_KEY.ETC_UID, res.uid)
            if (res.third_code) {
              localStorage.setItem(
                ETC.LOCAL_STORAGE_KEY.PAHCZ_OPENID,
                res.third_code
              )
            }
            return ETC_AXIOS.post(
              response.config.url.replace(APP.HTTP_URL, ''),
              response.config.data
            )
          })
        }
        // console.warn('%c response url: ' + response.config.url.replace(APP.HTTP_URL, '') + ' => error:' + response.data.code + ' => msg:' + response.data.msg, 'color: blue', response.data.data)
        setTimeout(() => {
          v.$children[0].$refs.toast.$emit('loadingClose')
        })
        return Promise.reject(res)
      } else {
        setTimeout(() => {
          v.$children[0].$refs.toast.$emit('loadingClose')
        })
        v.$children[0].$refs.confirm.$emit('showConfirm', {
          content: '请求超时，请稍后再试'
        })
        return Promise.reject(new Error('request error!'))
      }
    },
    err => {
      setTimeout(() => {
        v.$children[0].$refs.toast.$emit('loadingClose')
      })
      v.$children[0].$refs.confirm.$emit('showConfirm', {
        content: '请求超时，请稍后再试'
      })
      return Promise.reject(err)
    }
  )
  v = new Vue({
    router,
    store,
    render: h => h(AppVue)
  }).$mount('#app')
}
